import { english, type Localisation } from "./en";

export const englishCA: Localisation = {
  ...english,
  dateFormats: {
    ...english.dateFormats,
    currentDateFormat: "eee, LLLL do",
    currentTimeFormat: "h:mma",
    hoursMinutes: "h:mma",
    dateDayMonth: "eeee, LLLL do",
    dateDay: "do eeee",
  },
};
